/**
 * State Persistence Utilities
 * Provides methods to persist and restore Redux state for better UX
 */

// Save state to sessionStorage (survives page refresh but not tab close)
export const saveStateToSession = (state) => {
  try {
    const stateToSave = {
      // Only persist non-sensitive data
      products: {
        products: state.products?.products || [],
        status: state.products?.status || 'idle',
        error: null
      },
      orders: {
        items: state.orders?.items || [],
        status: state.orders?.status || 'idle',
        error: null
      },
      customers: {
        items: state.customers?.items || [],
        status: state.customers?.status || 'idle',
        error: null
      },
      analytics: {
        data: state.analytics?.data || null,
        status: state.analytics?.status || 'idle',
        error: null
      },
      store: {
        current: state.store?.current || null,
        status: state.store?.status || 'idle',
        error: null
      },
      onboarding: state.onboarding || {
        progress: null,
        steps: [],
        status: 'idle',
        error: null
      },
      campaigns: {
        campaigns: state.campaigns?.campaigns || [],
        status: state.campaigns?.status || 'idle',
        error: null
      },
      customerGroups: {
        groups: state.customerGroups?.groups || [],
        allTags: state.customerGroups?.allTags || [],
        status: state.customerGroups?.status || 'idle',
        error: null
      },
    };
    
    const serializedState = JSON.stringify(stateToSave);
    sessionStorage.setItem('merchantState', serializedState);
  } catch (error) {
    console.warn('Failed to save state to sessionStorage:', error);
  }
};

// Load state from sessionStorage
export const loadStateFromSession = () => {
  try {
    const serializedState = sessionStorage.getItem('merchantState');
    if (serializedState === null) {
      return undefined;
    }
    const parsedState = JSON.parse(serializedState);
    console.log('Loaded persisted state:', parsedState);
    return parsedState;
  } catch (error) {
    console.warn('Failed to load state from sessionStorage:', error);
    return undefined;
  }
};

// Clear persisted state
export const clearPersistedState = () => {
  try {
    sessionStorage.removeItem('merchantState');
  } catch (error) {
    console.warn('Failed to clear persisted state:', error);
  }
};

// Check if state is stale (older than 1 hour)
export const isStateStale = () => {
  try {
    const lastSaved = sessionStorage.getItem('merchantStateTimestamp');
    if (!lastSaved) return true;
    
    const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
    return Date.now() - parseInt(lastSaved) > oneHour;
  } catch (error) {
    return true;
  }
};

// Save state with timestamp
export const saveStateWithTimestamp = (state) => {
  saveStateToSession(state);
  try {
    sessionStorage.setItem('merchantStateTimestamp', Date.now().toString());
  } catch (error) {
    console.warn('Failed to save state timestamp:', error);
  }
};
